import request from "../utils/request.js"
// 新增咨询
export function saveTechnologyApi(params) {
    return request({
        url: "/technology/saveTechnology",
        method: "post",
        data: params,
    })
}
// 用户咨询列表
export function userConsultationListApi(params) {
    return request({
        url: "/technology/userConsultationList",
        method: "post",
        data: params,
    })
}
// 用户咨询列表
export function getTechnologyDetailApi(params) {
    return request({
        url: "/technology/detail/"+params,
        method: "get",
    })
}